<style lang="scss">
  @use "../../assets/css/design-system/colors";
  @use "../../assets/css/design-system/utils";
  @use "../../assets/css/design-system/mixins";

  button {
    border: 0;
    border-radius: 8px;
    cursor: pointer;
    background-color: transparent;
    padding: 0;
    &.skeleton {
      @include mixins.skeleton;
    }
    &:disabled {
      cursor: auto;
    }
    &.swHidden {
      visibility: hidden;
    }
  }
</style>

<script>
  import IconScale from "./IconScale.svelte";

  export let icon;
  export let size = "medium";
  export let color = "interfaceTransparentBlack_50";
  export let focusColor = "primary_60";
  export let mouseEnterColor = "interfaceTransparentBlack_80";
  export let backgroundColor = "";
  export let skeleton = false;

  let cls = "";
  export { cls as class };
  export let el;
  export let disabled = false;
  export let swHidden = false;

  export let onclick = () => {};

  let displayColor = color;

  // mouseenter triggers even if disabled
  const setMouseEnterColor = () => {
    if (disabled) return;
    displayColor = mouseEnterColor;
  };

  const setFocusColor = () => {
    displayColor = focusColor;
  };

  const resetColor = () => {
    displayColor = color;
  };
</script>

<button
  bind:this={el}
  class={cls}
  class:skeleton
  on:click={onclick}
  on:keydown={(e) => e.key === "Enter" && onclick(e)}
  on:mouseenter={setMouseEnterColor}
  on:mouseleave={resetColor}
  on:focus={setFocusColor}
  on:blur={resetColor}
  {disabled}
  class:swHidden
  {...$$restProps}
>
  {#if $$slots.tooltip}
    <IconScale
      class={icon}
      color={displayColor}
      {backgroundColor}
      {size}
      {skeleton}
    >
      <span slot="tooltip"><slot name="tooltip" /></span>
    </IconScale>
  {:else}
    <IconScale
      class={icon}
      color={displayColor}
      {backgroundColor}
      {size}
      {skeleton}
    />
  {/if}
</button>
